'use strict';

var _classCallCheck = require("C:\\Ed Tech\\murtskuuniversitiests\\react\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("C:\\Ed Tech\\murtskuuniversitiests\\react\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Ed Tech\\murtskuuniversitiests\\react\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("C:\\Ed Tech\\murtskuuniversitiests\\react\\node_modules\\@babel\\runtime/helpers/assertThisInitialized");

var _inherits = require("C:\\Ed Tech\\murtskuuniversitiests\\react\\node_modules\\@babel\\runtime/helpers/inherits");

var _wrapNativeSuper = require("C:\\Ed Tech\\murtskuuniversitiests\\react\\node_modules\\@babel\\runtime/helpers/wrapNativeSuper");

var Stringify = require('./stringify');

var internals = {};

module.exports = /*#__PURE__*/function (_Error) {
  _inherits(_class, _Error);

  function _class(args) {
    var _this;

    _classCallCheck(this, _class);

    var msgs = args.filter(function (arg) {
      return arg !== '';
    }).map(function (arg) {
      return typeof arg === 'string' ? arg : arg instanceof Error ? arg.message : Stringify(arg);
    });
    _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, msgs.join(' ') || 'Unknown error'));

    if (typeof Error.captureStackTrace === 'function') {
      // $lab:coverage:ignore$
      Error.captureStackTrace(_assertThisInitialized(_this), exports.assert);
    }

    return _this;
  }

  return _class;
}( /*#__PURE__*/_wrapNativeSuper(Error));